import React, { useEffect, useState } from 'react'
import { useFileDispatch } from '../context/FileContext';
import { api } from '../api/apis';

const SelectExampleTextFile = ({setFileHandler}) => {
  const [, textFile,, selectTextFileHandler,,,, resetStatisticsHandler] = useFileDispatch();
  const [selectedFile, setSelectedFile] = useState("");
  const [exampleTextFiles, setExampleTextFiles] = useState([]);

  const textFileHandler = (event) => {
    selectTextFileHandler(event.target.value);
    resetStatisticsHandler();
  }

  useEffect(() => {
    setSelectedFile(textFile);
  }, [textFile]);

  useEffect(() => {
    api.get("/api/getExampleTextFiles").then((res) => {
      setExampleTextFiles(res.data);
    }).catch((error) => {
      // alert(error);
    });
  }, []);

  return (
    <div className=' flex flex-col'>
        <label htmlFor='audioFile' className="mb-5 block text-xl font-semibold text-[#07074D]">
          Select an example text file from below
        </label>
        <select className=' bg-blue-600 text-white py-1 px-2 rounded-md' value={selectedFile} onChange={textFileHandler}>
            <option style={{display: "none"}}>Select text file</option>
            <option value={""}>Select Text</option>
            {exampleTextFiles.map((file) => <option value={file}>{file}</option>)}
        </select>
    </div>
  )
}

export default SelectExampleTextFile;